import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../components/Home"
import Arhiva from "@/components/Arhiva"

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/arhiva/:alias',
        name: 'Arhiva',
        component: Arhiva
    },
]
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router